import {Message, MessageBox} from 'element-ui';
import {DURATION_DEFAULT} from "../config/app";

/**
 * 消息提示模式，参考element-ui
 */
export const MSG_MODES = {
  MESSAGE: "message",
  MESSAGE_BOX: "messageBox",
};
/**
 * 消息类型，参考element-ui
 */
export const MSG_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
  ERROR: "error"
};

/**
 * Vuex 子模块调用该方法，向全局发送消息提示
 * example:
 *     const actions = {
 *        async initViews({dispatch}){
 *            setMessage({
 *              type:MSG_TYPES.SUCCESS,
 *              mode:MESSAGE_MODES.MESSAGE,
 *              message:"hello this is an example",
 *              onClose:(msg)=>{
 *                console.log("已关闭");
 *              }
 *            });
 *        }
 *     }
 *
 * @param message
 *
 *   message 结构如下:
 *   {
 *      type: < MSG_TYPES.INFO | MSG_TYPES.ERROR | MSG_TYPES.SUCCESS | MSG_TYPES.WARNING >, //消息类型
 *
 *      mode: < MESSAGE_MODE.MESSAGE | MESSAGE_MODE.MESSAGE_BOX >,//调用的 UI 组件 ，参考element-ui），默认 MESSAGE_MODE.MESSAGE
 *
 *      onClose: Function // 关闭时的处理动作，messageBox的 onOk,onCancel 以及 message 的 onClose 都会触发该函数
 *
 *      message: String | Function（h）=>{}, //消息提示内容，可以是字符串，或者自动以VNode，element-ui
 *
 *      onOk: Function // 点击确定的执行动作（只有messageBox有该项）
 *
 *      onCancel: Function // 点击取消时的执行动作（只有messageBox有该项）
 *
 *      ... //其他属性参考element-ui
 *   }
 */
export function setMessage(message) {
  if (!message.mode) {
    message.mode = MSG_MODES.MESSAGE;
  }
  if (message.mode === MSG_MODES.MESSAGE) {
    //如果没有设置duration，或者duration为0，
    //则重置为默认duration
    if (message["duration"] === undefined) {
      message.duration = DURATION_DEFAULT;
    }
  }
  displayMessage(message);
}

function displayMessage(message) {
    switch (message.mode) {
      case MSG_MODES.MESSAGE_BOX:
        displayMessageBoxInternal(message);
        break;
      default:
        displayMessageInternal(message);
    }
}

/**
 * 调用element-ui 的 options 显示消息
 * @param options
 * @returns {function(*=)}
 */
function displayMessageInternal(options) {
    Message({
      message: getContent(options.message),
      type: options.type,
      showClose: options.showClose === undefined? true : options.showClose,
      duration: options.duration,
      dangerouslyUseHTMLString: true,
      center: options.center,
      onClose: handleClose(options),
    })
}

/**
 * 调用element-ui 的 messageBox 显示消息
 * @param options
 */
function displayMessageBoxInternal(options) {

    MessageBox({
      title: options.title,
      message: getContent(options.message),
      type: options.type,
      beforeClose: handleClose(options),
      lockScroll: options.lockScroll,
      dangerouslyUseHTMLString: true,
      showCancelButton: options.showCancelButton,
      showConfirmButton: options.showConfirmButton,
      cancelButtonText: options.cancelButtonText,
      confirmButtonText: options.confirmButtonText,
      closeOnClickModal: options.closeOnClickModal,
      closeOnPressEscape: options.closeOnPressEscape,
      closeOnHashChange: options.closeOnHashChange,
      showInput: options.showInput,
      inputPlaceholder: options.inputPlaceholder,
      inputType: options.inputType,
      inputValue: options.inputValue,
      inputPattern: options.inputPattern,
      inputValidator: options.inputValidator,
      inputErrorMessage: options.inputErrorMessage,
      center: options.center,
      roundButton: options.roundButton,
      callback: (action, instance) => {
        if (action === "confirm") {//处理confirm
          handleConfirm(options);
        } else {//处理取消
          handleCancel(options);
        }
      }
    })
}

function getContent(message) {
  // return app => {
  //   if (message instanceof Function) {
  //     return message(app.$createElement)
  //   } else {
      return message;
    // }
  // }
}


function handleClose(options) {
    if (options.onClose) {
      options.onClose(options);
    }
}

function handleConfirm(options) {
    if (options.onOk) {
      options.onOk(options);
    }
    handleClose(options);
}

function handleCancel(options) {
    if (options.onCancel) {
      options.onCancel(options);
    }
    handleClose(options);
}




// WEBPACK FOOTER //
// ./src/libs/message.js